import Wrapper from "../../components/sectionWrapper";
import { media } from "../../libs/media";
import { Link } from "react-router-dom";
import { useLangContext } from "../../components/translateContext";
import Messages from "./translations/index.json";
import qualMessage from "../../page/LandingPage/translations/QualitySection.json";
import buttonText from "../../translations/button.json";
import { Slide } from "react-reveal";
import OnlineOverview from "./OnlineOverview";
import Secured from "../LandingPage/Secured";
import PaymentLinkOverview from "../sharableLink/PaymentLinkOverview";
import OnlineEffortTime from "./OnlineEffortTime";
import OnlineTestimonial from "./OnlineTestimonial";
const { lowFees, security, easyHandling } = media.Icons[1];

export default function OnlinePaymentPage() {
  const { Lang } = useLangContext();
  const Infos = Messages[Lang];
  const InfosQuality = qualMessage[Lang];
  const btnMsg = buttonText[Lang];
  return (
    <>
      <div >
        <OnlineOverview/>
        <OnlineEffortTime/>
        <PaymentLinkOverview/>
        <OnlineTestimonial/>
        <Secured/>

      </div>
  
    </>
  );
}
